<template>
  <template v-if="issues">
    <v-list lines="two">
      <v-list-item
        v-for="item in issues"
        :key="item.number || 0"
        :to="to(item.number)"
      >
        <v-list-item-title><IssueTitle :issue="item" /></v-list-item-title>
        <v-list-item-subtitle>
          <v-chip v-for="label in item.labels" :key="label.id || 0"
            >{{ label.name }}
          </v-chip>
        </v-list-item-subtitle>
      </v-list-item>
    </v-list>
  </template>
</template>
<script setup lang="ts">
import type { Issue } from "../gen/forgejo-vue";

const props = defineProps<{
  owner: string;
  repo: string;
  issues: Issue[];
}>();

function to(index?: number) {
  return {
    name: "/repos/[owner]/[repo]/issues/[index]/",
    params: { owner: props.owner, repo: props.repo, index },
  };
}
</script>
